import { forwardRef } from 'react'
import { useListBox } from '@react-aria/listbox'
import Styles from '../ListBox.module.scss'
import cx from 'classnames'
import { NonVirtualizedListBoxBaseProps } from '../Types'
import { Option } from './Option'
import { useObjectRef } from 'utils/useObjectRef'
import { Section } from './Section'

const NonVirtualizedListBoxBase = forwardRef<HTMLDivElement, NonVirtualizedListBoxBaseProps<object>>((props, fRef) => {
  const ref = useObjectRef(fRef)
  const { state, useFullWidth = false, wrapperClassName } = props
  const { listBoxProps } = useListBox(props, state, ref)

  return (
    <div
      {...listBoxProps}
      ref={ref}
      className={cx(Styles.root, { [Styles.useFullWidth]: useFullWidth }, wrapperClassName)}
    >
      {[...state.collection].map((item) =>
        item.type === 'section' ? (
          <Section key={item.key} section={item} state={state} optionClassName={props.optionClassName} />
        ) : (
          <Option key={item.key} item={item} state={state} className={props.optionClassName} />
        ),
      )}
    </div>
  )
})

export { NonVirtualizedListBoxBase }
